import type { BodyRouteParamsRequest } from '@pba/react-utils';
import type { paths } from '@pba/types-openapi-client';
import { type ApiClientResponse, apiClient, routes } from 'common/services';

type ResponseType = paths['/v3/users/{id}']['patch']['responses']['200']['content']['application/json'];
type UserPathRequestParams = paths['/v3/users/{id}']['patch']['parameters']['path'];
type UserRequestBody = paths['/v3/users/{id}']['patch']['requestBody']['content']['application/json'];

export const updateUserProfile = async ({
  body,
  routeParams: { id },
}: BodyRouteParamsRequest<UserRequestBody, UserPathRequestParams>) =>
  apiClient.patch<ResponseType, ApiClientResponse<ResponseType>>(routes.user.patch(id), body);
